import { EnterpriseInitiativeLoaderState } from './State'

import {
  SET_ENTERPRISE_INITIATIVE_INFO,
  SET_IS_LOADING_ENTERPRISE_INITIATIVE_INFO,
  EnterpriseInitiativeLoaderAction
} from './Actions'

function enterpriseInitiativeLoaderReducer(
  state: EnterpriseInitiativeLoaderState,
  action: EnterpriseInitiativeLoaderAction
): EnterpriseInitiativeLoaderState {
  switch (action.type) {
    case SET_ENTERPRISE_INITIATIVE_INFO:
      return Object.assign({}, state, { enterpriseInitiativeInfo: action.payload })
    case SET_IS_LOADING_ENTERPRISE_INITIATIVE_INFO:
      return Object.assign({}, state, { isLoadingEnterpriseInitiativeInfo: action.payload })
    default:
      return state
  }
}

export default enterpriseInitiativeLoaderReducer
